export enum BookingMode {
  REQUEST = 'request',
  INSTANT = 'instant'
}
